export default {
  title: {
    list: 'Routes',
    edit: 'Update the route',
    create: 'Create a new route',
    report: 'Routes distribution report',
  },
  table: {
    name: 'name',
    color: 'color',
    sector: 'sector',
    lane: 'lane',
    setter: 'route setter',
    grade: 'grade',
    settledAt: 'settled at',
    comments: 'comments',
    filter: {
      draft: 'in progress',
      archived: 'archived',
    },
  },
  tabs: {
    form: 'Edit',
    comment: 'Comments',
    summary: 'Summary',
    log: 'History',
  },
  form: {
    name: 'Name of the route',
    sector: 'Sector',
    lane: 'Lane',
    color: 'Color',
    setter: 'Route setter',
    settledAt: 'Route settled at',
    draft: 'In progress',
    grade: 'Grade',
    path: 'Path',
    variations: 'Options',
    submit: 'Save',
    display: 'See the topo',
  },
  variant: {
    short: 'Variants',
    menu: 'Show variant',
    button_browse: 'Show',
    button_create: 'create',
    title: 'Create a variant',
    warning_one: 'There is a variant of this route',
    warning_other: 'There are {{count}} variants of this route',
  },
  formHelper: {
    draft: 'Climbers are visually informed that the route may be subject to change',
    path: 'The path allows to visually represent the position of the holds',
    variations: 'Among all the possible options on the line, which ones are allowed',
  },
  tooltip: {
    draft: 'In progress',
    archived: 'Route archived',
    fetchRoute: 'Random name',
    filter: {
      draft: 'Filter in progress routes',
      archived: 'Filter archived routes',
    },
  },
  helper: {
    no_lane: 'no lane',
    no_color: 'no color',
    scroll: 'Use CTRL + scroll to zoom the topo',
  },
  error: {
    no_sector: 'You need to create a sector first.',
  },
  summary: {
    empty: 'no comments available',
    grades: 'Number of comments per grade',
    likes: 'Distribution of comments per like',
    tickTypes: 'Distribution of comments per tick type',
    like: {
      yes: 'liked',
      no: 'neutral',
    },
    tickType: {
      working: 'project',
      redpoint: 'red point',
      flash: 'flash',
      onsight: 'onsight',
    },
  },
  log: {
    types: {
      'route-created': 'Route created',
      'route-modified': 'Route modified',
      'route-archived': 'Route archived',
    },
    buttons: {
      modify: 'Mark the route modified',
    },
  },
  add: {
    button: 'New route',
  },
  report: {
    button: 'Distribution',
    header: {
      total: 'total',
      grade: 'grade',
      target: 'target',
      current: 'current',
      diff: 'delta',
    },
  },
  archive: {
    button: 'Archive this route',
    confirm: {
      title: 'Please confirm the archiving of the "{{name}}" route',
      submit: 'Archive',
      warning_one: 'There is another variant of this route',
      warning_other: 'There are {{count}} variants of this route',
      helper_one: 'archive the variant too',
      helper_other: 'archive the variants too',
    },
  },
  unarchive: {
    button: 'Unarchive this route',
    confirm: {
      title: 'The route "{{name}}" has been archived, do you want to reverse this action and restore the route?',
      submit: 'Unarchive',
    },
  },
}
